import { create } from '~/utils/store/createStore';
import type { WebSearch } from '~/views/alfred/research/services/conversations-service';

interface ScheduleDrawerState {
  isOpen: boolean;
  editingTaskId: string | null;
  initialQuery: string | null;
  priorWebSearch: WebSearch | null;
  drawerKey: number;
}

interface ScheduleDrawerActions {
  open: (query?: string, priorWebSearch?: WebSearch) => void;
  openForEdit: (taskId: string) => void;
  close: () => void;
}

type ScheduleDrawerStore = ScheduleDrawerState & ScheduleDrawerActions;

export const useScheduleDrawerStore = create<ScheduleDrawerStore>(
  (set, get) => ({
    editingTaskId: null,
    initialQuery: null,
    priorWebSearch: null,
    isOpen: false,
    drawerKey: 0,
    open: (query?: string, priorWebSearch?: WebSearch) =>
      set({
        isOpen: true,
        editingTaskId: null,
        initialQuery: query ?? null,
        priorWebSearch: priorWebSearch ?? null,
        drawerKey: get().drawerKey + 1,
      }),
    openForEdit: (taskId: string) =>
      set({
        isOpen: true,
        editingTaskId: taskId,
        initialQuery: null,
        priorWebSearch: null,
        drawerKey: get().drawerKey + 1,
      }),
    close: () =>
      set({
        isOpen: false,
        editingTaskId: null,
        initialQuery: null,
        priorWebSearch: null,
      }),
  })
);
